import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore'
import { getLanguage, isNullOrUndefined } from '../../../store/storeFunctions';
import { BbSelectNoFormik } from '../../styling/bbInput'
import { Translate, withLocalize } from 'react-localize-redux';
import { selectDefaultStyles } from '../../styling/selectDefaultStyles';

import './finColumnOrderManager.scss';

class FinColumnOrderManager extends React.Component {

    orderByPrefix = 'Report.Financial.OrderBy.';
    options = ['Descending', 'Ascending'];

    state = {
        initialized: false,
        selectedOption: this.options[0],
    };

    componentDidMount() {
        if (!this.state.initialized) {
            const info = this.props.getSection([this.props.sectionId]);
            if (!isNullOrUndefined(info) && !isNullOrUndefined(info.data)) {
                this.setState({ 
                    initialized: true, 
                    selectedOption: !isNullOrUndefined(info.params) && !isNullOrUndefined(info.params.ascending) && (info.params.ascending.toString().toLowerCase() === "true") ? 
                        this.options[1] : this.options[0] 
                });
            }
        }
    }

    render() {
        return (
            <div className='fin-column-order-manager'>
                <span><Translate id='SearchResult.Display' />:</span>
                <span className='fin-column-order-selection-wrapper' >
                    <BbSelectNoFormik
                        value={{ value: this.state.selectedOption, label: getLanguage() === 'sk-SK' || getLanguage() === 'cs-CZ' ? this.props.translate(`${this.orderByPrefix}${this.state.selectedOption}`).toLowerCase() : this.props.translate(`${this.orderByPrefix}${this.state.selectedOption}`) }}
                        options={this.options.map(opt => ({ value: opt, label: getLanguage() === 'sk-SK' || getLanguage() === 'cs-CZ' ? this.props.translate(`${this.orderByPrefix}${opt}`).toLowerCase() : this.props.translate(`${this.orderByPrefix}${opt}`) }))}
                        onChange={o => this.handleChange(o)} isSearchable={false} styles={{ ...selectDefaultStyles, indicatorsContainer: base => base }}
                    />
                </span>
            </div>
        )
    }

    handleChange = selectedOption => {
        this.props.setSectionParams([this.props.sectionId], { ascending: selectedOption.value === this.options[1] }, () => 
        {
            const info = this.props.getSection([this.props.sectionId]);
            this.props.requestFetchSection([this.props.sectionId], info.params);
        })
        this.setState({ selectedOption: selectedOption.value });
    };
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(FinColumnOrderManager));